import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { CurriculumVideoProductAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import Details from './Details'
import Summary from './Summary'

export default function CurriculumVideoProductStatCard({
  product,
}: {
  product: CurriculumVideoProductAPIStat
}): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const cardName = `${product.subjectTitle} - ${product.title}`

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <Summary onClick={onToogle} product={product} showContent={showContent} />
      {showContent && <Details product={product} />}
    </ProductCardContainer>
  )
}
